import { useEffect, useState } from 'react'
import { addHours, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Theme, useMediaQuery } from '@mui/material'

import './styles/index.css'
import { Payment, PaymentNovelty } from '../../types'
import AccountIcon from '../../assets/icons/account-icon.svg'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'
import { getNoveltyIconByType, getNoveltyShortDescriptionByType } from '../../lib'
import Chip from '../common/chip'

export const PaymentToReviewListItem = ({
  paymentData,
  handleSetSelectedPayment,
  handleGoToPaymentDetails
}: {
  paymentData: Partial<Payment>
  handleGoToPaymentDetails: (paymentId: string) => void
  handleSetSelectedPayment?: (paymentData: Partial<Payment>) => void
}) => {
  const { t } = useTranslation(['payments-to-review-management', 'common'])

  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'))
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'))
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

  const [paymentNovelties, setPaymentNovelties] = useState<Array<PaymentNovelty>>([])

  useEffect(() => {
    if (paymentData) {
      const paymentNoveltiesSortted = paymentData.novelties?.sort(function (thisNovelty, nextNovelty) {
        return thisNovelty.resolved === nextNovelty.resolved ? 0 : nextNovelty.resolved ? -1 : 1
      }) as Array<PaymentNovelty>
      const paymentNoveltiesToDisplay = paymentNoveltiesSortted.filter((paymentNoveltyData) => paymentNoveltyData.resolved === false)

      setPaymentNovelties(paymentNoveltiesToDisplay)
    }
  }, [paymentData])

  return (
    <div
      className="payment-list-item-data-container"
      onClick={() => {
        if (paymentNovelties?.length === 0) {
          handleSetSelectedPayment?.(paymentData)
          return
        }

        handleGoToPaymentDetails(String(paymentData._id))
      }}
    >
      <div className="customer-company-table-column customer-company-table-width-10 display-none-xlg">
        <div className="customer-details-list-item-icon">
          <img
            src={CalendarIcon}
            alt="calendar-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{format(addHours(new Date(String(paymentData?.createdAt)), 5), 'dd/MM/yyyy')}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45 customer-company-table-width-70-md-down">
        <div className="customer-details-list-item-icon">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="customer-details-list-item-text">{paymentData.customerData?.registeredFullName?.toUpperCase()}</div>
      </div>
      <div className="customer-company-table-column customer-company-table-width-45 novelties-container customer-company-table-width-30-md-down">
        {paymentNovelties?.length === 0 && (
          <Chip
            status="reviewed"
            label={t('paymentStatus.reviewed', { ns: 'customer-details-management' })}
          />
        )}
        {smDown && (
          <>
            {Array.isArray(paymentNovelties) && paymentNovelties?.length > 0 && (
              <div className="novelty-container">
                <div className="novelty-text">{`+${Number(paymentNovelties?.length)}`}</div>
                <div className="novelty-icon">
                  <img
                    src={getNoveltyIconByType['empty-bank-name']}
                    alt="empty-bank-data-registry-icon"
                  />
                </div>
              </div>
            )}
          </>
        )}
        {smUp && (
          <>
            {paymentNovelties.length > 0 && (
              <div className="novelty-container">
                <div className="novelty-icon">
                  <img
                    src={(getNoveltyIconByType as { [key: string]: string })[paymentNovelties?.[0].type ?? '']}
                    alt="empty-bank-data-registry-icon"
                  />
                </div>
                <div className="novelty-text">{`${(getNoveltyShortDescriptionByType as { [key: string]: string })[paymentNovelties?.[0].type ?? '']}`}</div>
              </div>
            )}
          </>
        )}
        {mdUp && (
          <>
            {Array.isArray(paymentNovelties) && paymentNovelties?.length >= 2 && (
              <div className="novelty-container">
                <div className="novelty-icon">
                  <img
                    src={(getNoveltyIconByType as { [key: string]: string })[paymentNovelties?.[1].type ?? '']}
                    alt="empty-bank-data-registry-icon"
                  />
                </div>
                <div className="novelty-text">{`${(getNoveltyShortDescriptionByType as { [key: string]: string })[paymentNovelties?.[1].type ?? '']}`}</div>
              </div>
            )}
          </>
        )}
        {lgUp && (
          <>
            {Array.isArray(paymentNovelties) && paymentNovelties?.length >= 3 && (
              <div className="novelty-container">
                <div className="novelty-text">{`+${Array.isArray(paymentNovelties) && paymentNovelties?.length >= 3 ? Number(paymentNovelties?.length) - 2 : ''}`}</div>
                <div className="novelty-icon">
                  <img
                    src={getNoveltyIconByType['empty-bank-name']}
                    alt="empty-bank-data-registry-icon"
                  />
                </div>
              </div>
            )}
          </>
        )}
        <div>
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}
